/**
 * ETAP 7 – English title/description for the /en/ pages.
 * Keys are Polish (canonical) paths without the /en prefix and without a trailing slash.
 */
export const SEO_META_EN: Record<string, { title: string; description: string }> = {
  "/": {
    title: "3D domed sticker manufacturer – resin doming for B2B",
    description:
      "Manufacturer of 3D domed stickers (resin doming) for business. Durability over 15 years, online quote in 15 seconds, any shape and 14 films.",
  },
  "/produkty": {
    title: "Products – 3D domed stickers, labels and nameplates",
    description:
      "Our product range: 3D domed stickers, flat labels, 3D nameplates and resin doming on customer material. Online quote for business orders.",
  },
  "/kalkulator": {
    title: "3D sticker price calculator – instant online quote",
    description:
      "Calculate the price of 3D domed stickers online: enter size, quantity and film to see the net price in PLN and EUR, then download a PDF offer.",
  },
  "/zastosowania-branzowe": {
    title: "3D stickers – applications across industries",
    description:
      "How 3D domed stickers are used in automotive, industry, electronics, sports and advertising. Materials, requirements and examples for each sector.",
  },
  "/realizacje": {
    title: "Examples of our work – 3D sticker gallery",
    description:
      "Videos of finished 3D domed stickers: logos, nameplates and emblems in different films. See the dome effect before you order.",
  },
  "/baza-wiedzy": {
    title: "3D sticker knowledge base – technical guides",
    description:
      "Guides for business: print file requirements, film selection, resin durability, mounting, costs and the B2B ordering process.",
  },
  "/o-nas": {
    title: "About us – 3D domed sticker manufacturer",
    description:
      "We manufacture 3D domed stickers sealed with polyurethane resin for business customers across the European Union. Learn about our process.",
  },
  "/kontakt": {
    title: "Contact – request a 3D sticker quote",
    description:
      "Contact our 3D domed sticker production team. Send your artwork and quantity to receive a quote for your business order.",
  },
  "/blog": {
    title: "3D sticker blog – guides and industry insights",
    description:
      "Articles about 3D domed stickers: design guides, material comparisons and industry inspiration from the manufacturer.",
  },
  "/naklejki-doming": {
    title: "Doming stickers – resin doming technology",
    description:
      "Doming stickers explained: how polyurethane resin doming works, what it protects and which markings benefit from it most.",
  },
  "/naklejki-wypukle": {
    title: "Domed stickers – raised resin stickers for business",
    description:
      "Domed stickers with a raised resin layer: premium look, up to 15 years durability and full-colour print on 14 different films.",
  },
  "/naklejki-z-logo": {
    title: "Company logo stickers – 3D branding for products",
    description:
      "3D stickers with your company logo. A raised resin dome gives products, equipment and vehicles a premium, long-lasting brand mark.",
  },
  "/polityka-prywatnosci": {
    title: "Privacy policy",
    description: "How we process personal data of customers and website visitors.",
  },
  "/polityka-cookies": {
    title: "Cookie policy",
    description: "Information about cookies used on our website.",
  },
};

export const getEnMeta = (polishPath: string) => {
  const key = polishPath !== "/" && polishPath.endsWith("/") ? polishPath.slice(0, -1) : polishPath;
  return SEO_META_EN[key];
};
